import type { TeamMember } from "@/app/hooks/useDagStore";

/**
 * Calculate counts for each team, including "All"
 */
export const calculateTeamCounts = (
  teamMembers: TeamMember[],
  allTeams: string[],
): Record<string, number> => {
  const counts: Record<string, number> = {
    All: teamMembers.length,
  };

  // Initialize all teams with 0
  for (const team of allTeams) {
    counts[team] = 0;
  }

  // Count members per team
  for (const member of teamMembers) {
    if (member.team) {
      counts[member.team] = (counts[member.team] ?? 0) + 1;
    }
  }

  return counts;
};
